import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';

export const INDEX_PATH = '/';

export default (<Route
  index
  key={INDEX_PATH}
  lazy={async () => ({
    Component: (await import(
      /* webpackChunkName: 'homepage' */
      '../components/discovery/homepage'
    )).default,
  })}
/>);
